import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.replace";
import { StringToRgba, RgbaToUrl } from '@swp/colors';
export default (function (src, color) {
  if (!src || typeof src !== 'string') {
    return undefined;
  }

  if (/\.svg$/.test(src) && color) {
    src = src.replace(process.env.CDN_HOST + 'o/', process.env.CDN_HOST + 't/');
    src = src.replace(/\.svg$/, "_col=" + RgbaToUrl(StringToRgba(color)) + "_.svg");
  }

  return src.replace(/%2C/g, 'x');
});